import React from 'react';
import { Flame } from 'lucide-react';
interface UrgencyBarProps {
  label: string;
  text: string;
  spotsLeft: string;
}
export function UrgencyBar({
  label,
  text,
  spotsLeft
}: UrgencyBarProps) {
  return <div className="sticky top-0 z-40 border-b border-[#C65C53]/30 bg-[#1B0F0E]/95 backdrop-blur-sm" data-id="element-328" data-mp="16fu85shkj45u">
      <div className="mx-auto flex max-w-6xl items-center gap-2.5 px-4 py-2.5 sm:px-6" data-id="element-329" data-mp="1bfgnq8kvcwht">
        <span className="relative flex h-2 w-2 shrink-0" data-id="element-330" data-mp="drygj26uw2fx">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#C65C53] opacity-70" data-id="element-331" data-mp="dtj58b6hor5v" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-[#C65C53]" data-id="element-332" data-mp="npmahpwn15x1" />
        </span>
        <p className="min-w-0 font-mono text-[9px] uppercase leading-relaxed tracking-[0.1em] text-[#E4B2AC] sm:text-[10px] sm:tracking-[0.13em]" data-id="element-333" data-mp="rr7udv7lakgq">
          <span className="font-semibold text-[#F0C9C4]" data-id="element-334" data-mp="1z3zu2ikcyz79">{label}:</span> {text}
        </p>
        <span className="ml-auto hidden shrink-0 items-center gap-1.5 font-mono text-[9.5px] uppercase tracking-[0.14em] text-[#E4B2AC] md:flex" data-id="element-335" data-mp="235bmswyj40jo">
          <Flame aria-hidden="true" className="h-3.5 w-3.5" data-id="element-336" data-mp="1hxof0ngl4nal" />
          {spotsLeft}
        </span>
      </div>
    </div>;
}